import { render, staticRenderFns } from "./addDetail.vue?vue&type=template&id=185c4f01"
import script from "./addDetail.vue?vue&type=script&lang=js"
export * from "./addDetail.vue?vue&type=script&lang=js"
import style0 from "./addDetail.vue?vue&type=style&index=0&id=185c4f01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports